import clsx, { type ClassValue } from 'clsx'

/** Conditional className joiner. Thin alias so call sites read the same everywhere. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs)
}
